import requestMaker from 'lib';

export const processCase = casePayload => {
  const baseQuery = `/proxy/prv/gw/pc`;
  const params = {};
  const payload = { ...casePayload };
  return requestMaker(baseQuery, { params, payload });
};

export const getCareTeamFilterOptions = data => {
  const baseQuery = `/proxy/pbl/gw/gcfo`;
  const payload = { ...data };
  const params = {};
  return requestMaker(baseQuery, { params, payload });
};

export const fetchCTList = data => {
  const baseQuery = `/proxy/uml/pbl/gw/fct`;
  const payload = { ...data };
  const params = {};
  return requestMaker(baseQuery, { params, payload });
};
